// src/components/ProblemSolution.js
import React from 'react';
import { AlertTriangle, CheckCircle, ArrowRight } from 'lucide-react';
import '../styles/ProblemSolution.css';

const ProblemSolution = () => {
  const challenges = [
    {
      problem: "Fragmented Architecture",
      impact: "Maintenance overhead, technical debt",
      solution: "Modular .NET cores with clear boundaries"
    },
    {
      problem: "Compliance Risk",
      impact: "Audit failures, regulatory exposure",
      solution: "Security baselines and audit trails"
    },
    {
      problem: "Slow Releases",
      impact: "Delayed market response, lost revenue",
      solution: "CI/CD pipelines with automated testing"
    },
    {
      problem: "Unclear Ownership",
      impact: "Finger-pointing, delayed resolution",
      solution: "Living documentation and runbooks"
    }
  ];

  return (
    <section className="problem-solution-section">
      <div className="problem-solution-container">
        <div className="section-header-center">
          <span className="section-badge">Enterprise Challenges, Solved</span>
          <h2 className="section-title">
            From Risk to Reliability
          </h2>
          <p className="section-description">
            We transform common enterprise pain points into competitive advantages through proven architecture and processes.
          </p>
        </div>

        <div className="challenges-grid">
          {challenges.map((item, index) => (
            <div key={index} className="challenge-card">
              <div className="challenge-problem">
                <div className="problem-header">
                  <AlertTriangle className="problem-icon" />
                  <h3 className="problem-title">{item.problem}</h3>
                </div>
                <p className="problem-impact">{item.impact}</p>
              </div>

              <div className="solution-arrow">
                <ArrowRight className="arrow-icon" />
              </div>

              <div className="challenge-solution">
                <div className="solution-header">
                  <CheckCircle className="solution-icon" />
                  <h3 className="solution-title">Our Solution</h3>
                </div>
                <p className="solution-approach">{item.solution}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="solution-cta">
          <p className="solution-cta-text">
            See how we've solved these challenges for 75+ enterprise clients
          </p>
          <button className="solution-cta-button">
            Request Architecture Audit
            <ArrowRight className="button-arrow" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;